import React, { useState, Component } from "react";
import logo from "../../assets/patho-logo-no-bg.png";
import chevronLeft from '../../assets/chevronLeft.svg'
import { Image } from "react-bootstrap";
import {
  Input,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  CardTitle,
  CardText,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./ExtLogin.css";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "../../AppInsights";
import jwt_decode from "jwt-decode";
import userIcon from '../../assets/user-icon.png'
import passwordIcon from '../../assets/password-icon.png'
import { useMsal } from "../../msal-context";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";

const decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : null;
const role = decoded ? (decoded.roles ? decoded.roles[0] : decoded.lab || '') : '';
let arr = [];
const rolesEnv = process.env.REACT_APP_ROLES || 'Admin,User,Manager';
rolesEnv.split(",").forEach((role) => {
  arr.push({ value: role, label: role });
});
let user;


const ExtLogin = (props) => {
  const history = useHistory()
  const { extLogin, passwordReset } = useMsal();
  const [username, setUserName] = useState(localStorage.getItem('mail') == null || localStorage.getItem('mail').length == 0 ? '' : localStorage.getItem('mail'))
  const [password, setPassword] = useState('')
  const [forgotPassword, setForgotPassword] = useState(true)
  const [error, setError] = useState('')
  const [passwordResetError, setPasswordResetError] = useState('')
  const [passwordResetSuccess, setPasswordResetSuccess] = useState('')

  async function ValidateEmailPasswordReset(mail) {
    if (String(mail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      forgotPasswordFunction(username)
    }
    else{
      setPasswordResetError('Please enter a valid email.')
    }
  }

  async function ValidateEmail(mail) {
    localStorage.setItem('mail', mail)
    if (password == '' || password.length == 0) {
      setError('Please enter a password')
      return false
    }
    else if (String(mail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      setError('')
      let response = await extLogin(username, password)
      if (response == 'Error') {
        setError('A user with this email and password was not found.')
      }
      else if (response.data.token) {
        window.location.href = '/dashboard'
      }
    }
    return (false)
  }


  async function forgotPasswordFunction(username) {
    let data = {
      email: username
    }
    const response = await passwordReset(data)
    if (response == 'Error') {
      setPasswordResetError('Password reset was unsuccessful. Please try again later.')
    }
    else {
      setPasswordResetSuccess('Password reset was a success. Please login using your new credentials!')
    }
  }


  return forgotPassword ? (
    <div className='login'>
      <Card className="card-elements card-center" data-tut="reactour__samples">
        <Image className="logo-center-image" src={logo} responsive />
        <h3 className='login-text'>Login</h3>
        <CardHeader className="text-color">
          Enter your credentials to login
        </CardHeader>
        <CardBody className="body-text">
          <Form method="post">
            <FormGroup>
              <div className="input-group mb-3 width-div">
                <div className="input-group-prepend">
                  <span className="input-group-text cil-user"><img className="user-icon" src={userIcon}></img></span>
                </div>
                <input onChange={(event) => { setUserName(event.target.value) }} value={username} id="login-username" className="form-control" type="email" placeholder="Email" />
              </div>
              <div className="input-group mb-3 width-div">
                <div className="input-group-prepend">
                  <span className="input-group-text cil-user"><img className="user-icon" src={passwordIcon}></img></span>
                </div>
                <input onChange={(event) => { setPassword(event.target.value) }} value={password} id="login-username" className="form-control" type="password" placeholder="Password" />
              </div>
              <div className="error-message">
                {error}
              </div>
              <div className='forgot-password' onClick={() => setForgotPassword(false)}>
                Forgot Password?
              </div>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter className="footer-buttons">
          <Button className="button-size remove-outline mr-2 margin-left" onClick={(event) => { localStorage.removeItem('error') }} href="/" outline color="secondary"><Image className="left-chevron" src={chevronLeft} responsive />Back</Button>
          <Input type="submit" onClick={(event) => { ValidateEmail(username) }} className="button-size custom-button save-upload-delete-button" id="save" value="Login" />
        </CardFooter>
      </Card>
    </div>
  ) : (
    <div className='login'>
      <Card className="card-elements card-center" data-tut="reactour__samples">
        <Image className="logo-center-image" src={logo} responsive />
        <h3 className='login-text'>Reset Password</h3>
        <CardHeader className="text-color">
          Enter the email
        </CardHeader>
        <CardBody className="body-text">
          <Form method="post">
            <FormGroup>
              <div className="input-group mb-3 width-div">
                <div className="input-group-prepend">
                  <span className="input-group-text cil-user"><img className="user-icon" src={userIcon}></img></span>
                </div>
                <input onChange={(event) => { setUserName(event.target.value) }} value={username} id="login-username" className="form-control" type="email" placeholder="Email" />
              </div>
              <div className="error-message">
                {passwordResetError}
              </div>
              <div className="success-message">
                {passwordResetSuccess}
              </div>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter className="footer-buttons">
          <Button className="button-size remove-outline mr-2 margin-left" onClick={(event) => { localStorage.removeItem('error'); setForgotPassword(true) }} outline color="secondary"><Image className="left-chevron" src={chevronLeft} responsive />Back</Button>
          <Input type="submit" onClick={(event) => { ValidateEmailPasswordReset(username) }} className="button-size custom-button-reset save-upload-delete-button" id="save" value="Reset Password" />
        </CardFooter>
      </Card>
    </div>
  );
}

export default withAITracking(
  reactPlugin,
  (ExtLogin),
  "ExtLogin",
  "ExtLogin"
);
